import jsQR from 'jsqr'

import { launchMediaLibraryAsync } from '@/utils/mediaPicker'

export function useScanQrCodeFromImage() {
  async function handleAddQrCode({ onSuccess, onError }: { onSuccess: (code: string) => void; onError: () => void }) {
    const result = await launchMediaLibraryAsync({
      mediaTypes: ['images'],
      quality: 1
    })
    if (result.canceled) return

    const { uri, width, height } = result.assets[0]
    const imageData = await imageDataFromSource(uri)
    const code = jsQR(imageData.data, width, height)
    if (code) onSuccess(code.data)
    else onError()
  }

  return { handleAddQrCode }
}

async function imageDataFromSource(source: string) {
  const image = Object.assign(new Image(), { src: source })
  await new Promise((resolve) => image.addEventListener('load', resolve, { once: true }))
  const context = Object.assign(document.createElement('canvas'), {
    width: image.width,
    height: image.height
  }).getContext('2d')
  if (!context) throw new Error('Unable to create a canvas for QR scanning')
  context.imageSmoothingEnabled = false
  context.drawImage(image, 0, 0)
  return context.getImageData(0, 0, image.width, image.height)
}
